import { createSelector } from "reselect"
import { get, noop } from "lodash"
import { getPeriod, getSelectedDate as getResearchTopicSelectedDate, getResearchTopicDate } from "modules/research-topic-root/selectors/dates"
import { getComparisonStartDate, getComparisonEarliestDate, getComparisonLatestDate, getComparisonWorkingPeriod, getComparisonEndDate, getComparisonSelectedDate } from "helpers/comparison-dates"
import { getComparisonNonOverlappingItems } from "helpers/comparison"
import { getUnmodeledDates } from "selectors/dates"
import { getSelectedComparisonType, getEarliestUploadedDate as getEarliestPortfolioUploadDate } from "./model"
import { getExperimentsAvailability, getSecuritiesAvailability, getPortfoliosAndBenchmarksAvailability } from "./availability"
import { getBaskets } from "resources/baskets"

const EMPTY_ARRAY = []
const getInstrumentAvailability = (state) => get(state, "global.data.instrumentAvailability.data.model.security.availability")
const getModelEarliestDate = (state, props) => get(props, "modelAvailability.securitiesStartDate")
const getRawComparisonItems = state => get(state, "modules.researchTopic.comparisonItems", EMPTY_ARRAY)
const getRawTopicSummaryDate = state => get(state, "modules.researchTopic.topicSummaryDate")
export const getModelCurrentDate = (state, props) => get(props, "modelAvailability.currentDate")

const getInstrumentLatestDate = createSelector(
  [getInstrumentAvailability, getModelCurrentDate],
  (instrumentAvailability, modelCurrentDate) => {
    let endDate = get(instrumentAvailability, "to")
    if (!endDate) return modelCurrentDate

    if (modelCurrentDate < endDate) {
      endDate = modelCurrentDate
    }
    return endDate
  },
)

export const getInstrumentEarliestDate = createSelector(
  [getInstrumentAvailability, getEarliestPortfolioUploadDate],
  (instrumentAvailability, earliestPortfolioUpload) => instrumentAvailability ? get(instrumentAvailability, "from") : earliestPortfolioUpload,
)

export const getLatestDate = createSelector(
  [getRawComparisonItems, getInstrumentLatestDate, getInstrumentEarliestDate, getSecuritiesAvailability],
  getComparisonLatestDate,
)

export const getItemsEarliestDate = createSelector(
  [noop, getInstrumentEarliestDate, getRawComparisonItems, getSecuritiesAvailability, getLatestDate, getSelectedComparisonType, getUnmodeledDates, getBaskets, getModelEarliestDate, getExperimentsAvailability],
  getComparisonEarliestDate,
)

export const getEarliestDate = createSelector(
  [getItemsEarliestDate, getResearchTopicDate],
  (earliestDate, researchTopicDate) => earliestDate < researchTopicDate ? researchTopicDate : earliestDate,
)

const getWorkingPeriod = createSelector(
  [getPeriod, getLatestDate, getEarliestDate],
  getComparisonWorkingPeriod,
)

export const getStartDate = createSelector(
  [getWorkingPeriod, getLatestDate, getEarliestDate],
  getComparisonStartDate,
)

export const getEndDate = createSelector(
  [getWorkingPeriod, getLatestDate],
  getComparisonEndDate,
)

export const getSelectedDate = createSelector(
  [getResearchTopicSelectedDate, getStartDate, getEndDate],
  getComparisonSelectedDate,
)

export const getTopicSummaryDate = createSelector(
  [getRawTopicSummaryDate, getResearchTopicSelectedDate, getEarliestDate, getLatestDate],
  (topicSummaryDate, selectedDate, earliestDate, latestDate) => getComparisonSelectedDate(topicSummaryDate || selectedDate, earliestDate, latestDate),
)
export const getNonOverlappingItems = createSelector(
  [getPortfoliosAndBenchmarksAvailability, getInstrumentEarliestDate, getRawComparisonItems, getSecuritiesAvailability, getEarliestDate, getLatestDate, getExperimentsAvailability],
  getComparisonNonOverlappingItems,
)
